import type { content as contentEn } from "../en/content";

export const content: typeof contentEn = {
  shared: {
    seoTitle: "SEO",
    metaTitleLabel: "Meta titulek",
    metaTitlePlaceholder: "SEO titulek (max 60 znaků)",
    metaDescriptionLabel: "Meta popis",
    metaDescriptionPlaceholder: "SEO popis (max 160 znaků)",
    featuredImageTitle: "Hlavní obrázek",
    sortOrderHint: "Nižší číslo = vyšší priorita",
    titleRequired: "Titulek je povinný",
    slugRequired: "Slug je povinný",
  },
  blog: {
    list: {
      title: "Blog",
      subtitle: "Správa článků na blogu",
      newPost: "Nový článek",
      searchPlaceholder: "Hledat články…",
      category: "Kategorie",
      allCategories: "Všechny kategorie",
      loadError: "Články se nepodařilo načíst. Zkuste to prosím znovu.",
      empty: "Žádné články",
      confirmDelete: "Opravdu chcete smazat „{{title}}“? Tuto akci nelze vrátit zpět.",
      featured: "Doporučený",
      readTime: "{{minutes}} min",
    },
    categories: {
      travelTips: "Cestovní tipy",
      culture: "Kultura",
      food: "Jídlo a gastronomie",
      nature: "Příroda",
      guides: "Průvodce",
      news: "Novinky",
    },
    form: {
      newTitle: "Nový článek",
      editTitle: "Upravit článek",
      basicInfo: "Základní informace",
      titlePlaceholder: "např. Velký průvodce vietnamským street foodem",
      slugLabel: "URL slug",
      slugPlaceholder: "např. velky-pruvodce-vietnamskym-street-foodem",
      categoryLabel: "Kategorie",
      noDestination: "Bez destinace",
      excerptLabel: "Perex",
      excerptPlaceholder: "Krátké shrnutí pro karty a výpisy (max 500 znaků)…",
      contentTitle: "Obsah",
      contentPlaceholder: "Napište obsah článku…",
      galleryTitle: "Fotogalerie",
      galleryPositionLabel: "Umístění:",
      galleryPositionText:
        "Galerie se zobrazuje jako mřížka přes celou šířku pod obsahem článku a štítky, nad souvisejícími zájezdy. Obrázky přímo do textu článku vložíte tlačítkem Obrázek v liště editoru obsahu výše.",
      authorTitle: "Autor",
      authorNameLabel: "Jméno autora",
      authorNamePlaceholder: "např. Tým CK Go2",
      readTimeLabel: "Doba čtení (minuty)",
      readTimePlaceholder: "např. 8",
      authorAvatarLabel: "Avatar autora",
      relatedTripsTitle: "Související zájezdy",
      relatedTripsHint: "Vyberte nejvýš {{max}} zájezdů. Vybráno: {{count}}.",
      relatedTripsLimitReached:
        "Dosažena mez {{max}} souvisejících zájezdů. Další přidáte, až některý odškrtnete.",
      relatedTripsLimitReachedHidden:
        "Dosažena mez {{max}} souvisejících zájezdů. Další přidáte, až některý odškrtnete nebo odeberete nepublikované.",
      relatedTripsHidden_one: "{{count}} vybraný zájezd není publikovaný a v seznamu chybí.",
      relatedTripsHidden_few: "{{count}} vybrané zájezdy nejsou publikované a v seznamu chybí.",
      relatedTripsHidden_other: "{{count}} vybraných zájezdů není publikovaných a v seznamu chybí.",
      relatedTripsRemoveHidden: "Odebrat nepublikované",
      tagsTitle: "Štítky",
      tagsPlaceholder: "poznavaci-zajezdy, asie, tipy-na-cestu",
      tagsHint: "Oddělujte čárkami",
      publishedAtLabel: "Datum publikace",
      publishedAtHint: "Nastaví se automaticky při změně stavu na Publikováno",
      featuredPost: "Doporučený článek",
    },
  },
  reviews: {
    list: {
      title: "Recenze",
      subtitle: "Správa zákaznických recenzí",
      newReview: "Nová recenze",
      searchPlaceholder: "Hledat recenze…",
      filterAll: "Vše",
      filterApproved: "Schválené",
      filterPending: "Čekající",
      loadError: "Recenze se nepodařilo načíst. Zkuste to prosím znovu.",
      empty: "Žádné recenze",
      from: "z {{location}}",
      featured: "Doporučená",
      video: "Video",
      pendingApproval: "Čeká na schválení",
      sourceCustomer: "Od zákazníka",
      tripMeta: "Zájezd: {{title}}",
      guideMeta: "Průvodce: {{name}}",
      destinationMeta: "Destinace: {{name}}",
      tripDateMeta: "Datum zájezdu: {{date}}",
      approve: "Schválit",
      revokeApproval: "Zrušit schválení",
      confirmDelete: "Opravdu chcete tuto recenzi smazat?",
    },
    form: {
      newTitle: "Nová recenze",
      editTitle: "Upravit recenzi",
      newSubtitle: "Vytvořte novou recenzi",
      editSubtitle: "Úprava recenze od {{name}}",
      customerInfoTitle: "Informace o zákazníkovi",
      customerNameLabel: "Jméno zákazníka",
      customerNamePlaceholder: "např. Jan Novák",
      customerLocationLabel: "Město/lokalita",
      customerLocationPlaceholder: "např. Praha",
      contentTitle: "Obsah recenze",
      ratingLabel: "Hodnocení",
      ratingOf: "{{rating}} z 5",
      reviewTitleLabel: "Titulek recenze",
      reviewTitlePlaceholder: "např. Nezapomenutelný zážitek!",
      reviewTextLabel: "Text recenze",
      reviewTextPlaceholder: "Napište recenzi zákazníka…",
      tripDateLabel: "Datum zájezdu",
      connectionsTitle: "Propojení",
      selectTrip: "-- Vyberte zájezd --",
      guideLabel: "Průvodce",
      selectGuide: "-- Vyberte průvodce --",
      selectDestination: "-- Vyberte destinaci --",
      approvedForDisplay: "Schváleno k zobrazení",
      showAsFeatured: "Zobrazit jako doporučenou",
      videoTitle: "Videorecenze",
      isVideoLabel: "Toto je videorecenze",
      videoUrlLabel: "URL videa",
      photosTitle: "Fotky k recenzi",
      photosHint: "Nahrajte fotky ze zájezdu zákazníka",
    },
  },
  faqs: {
    list: {
      title: "FAQ",
      subtitle: "Správa často kladených otázek pro web",
      addFaq: "Přidat FAQ",
      savingOrder: "Ukládám pořadí…",
      empty: "Zatím žádné FAQ položky",
      meta: "Pořadí: {{order}} | Stav: {{status}}",
      confirmDelete: "Smazat toto FAQ?",
      moveTopicUp: "Posunout téma nahoru",
      moveTopicDown: "Posunout téma dolů",
    },
    form: {
      newTitle: "Nové FAQ",
      editTitle: "Upravit FAQ",
      newSubtitle: "Vytvořte novou FAQ položku",
      editSubtitle: "Úprava: {{question}}…",
      topicLabel: "Téma",
      topicRequired: "Téma je povinné",
      topicPlaceholder: "např. Rezervace a platby",
      questionLabel: "Otázka",
      questionRequired: "Otázka je povinná",
      questionPlaceholder: "např. Jak si zarezervuji zájezd?",
      answerLabel: "Odpověď",
      answerRequired: "Odpověď je povinná",
      answerPlaceholder: "Napište odpověď…",
      topicSortOrderLabel: "Pořadí tématu",
      sortOrderLabel: "Pořadí (v rámci tématu)",
    },
  },
  quiz: {
    title: "Výsledky kvízu",
    subtitle: "Výsledky cestovatelského kvízu a statistiky",
    showStats: "Zobrazit statistiky",
    hideStats: "Skrýt statistiky",
    totalQuizzes: "Spuštění",
    newsletterSignups: "Přihlášky k newsletteru",
    last30Days: "Posledních 30 dní",
    topTrip: "Nejčastější zájezd",
    mostRecommended: "Nejčastěji doporučované zájezdy",
    mostRecommendedDestinations: "Nejčastěji doporučované země",
    topDestination: "Nejčastější země",
    variantSwitch: "Varianta průvodce",
    variantKviz: "Kvíz (zájezdy)",
    variantHledac: "Hledač (země)",
    thResult: "Výsledek",
    thClicks: "Prokliky",
    answerDistribution: "Rozložení odpovědí",
    resultUnavailable: "Už není k dispozici",
    clicksCount_one: "{{count}} proklik",
    clicksCount_few: "{{count}} prokliky",
    clicksCount_other: "{{count}} prokliků",
    questions: {
      tripType: "Typ cesty",
      duration: "Délka",
      bestMonth: "Měsíc",
      type: "Typ (starý kvíz)",
      budget: "Rozpočet (starý kvíz)",
      companion: "Společník (starý kvíz)",
      region: "Oblast (starý kvíz)",
    },
    times_one: "{{count}}×",
    times_few: "{{count}}×",
    times_other: "{{count}}×",
    thAnswers: "Odpovědi",
    thRecommended: "Doporučeno",
    empty: "Žádné výsledky kvízu",
    confirmDelete: "Opravdu chcete tento výsledek kvízu smazat?",
    subscribedNewsletter: "Přihlášen(a) k newsletteru",
    showing: "Zobrazeno {{from}}–{{to}} z {{total}} výsledků",
    answers: {
      adventure: "Dobrodružství",
      relax: "Relaxace",
      culture: "Kultura",
      nature: "Příroda",
      solo: "Sólo",
      couple: "Pár",
      family: "Rodina",
      friends: "Přátelé",
      northern: "Severní Vietnam",
      central: "Střední Vietnam",
      southern: "Jižní Vietnam",
      combination: "Kombinace",
    },
  },
  contentPages: {
    list: {
      title: "Stránky",
      subtitle: "Samostatné textové stránky, na které odkazují zájezdy",
      newPage: "Nová stránka",
      searchPlaceholder: "Hledat podle názvu nebo adresy…",
      loadError: "Stránky se nepodařilo načíst. Zkuste to znovu.",
      colTitle: "Název",
      colAddress: "Adresa",
      colStatus: "Stav",
      colDestination: "Destinace",
      colUpdated: "Poslední úprava",
      edit: "Upravit stránku {{title}}",
      delete: "Smazat stránku {{title}}",
      viewOnWeb: "Zobrazit stránku {{title}} na webu",
      confirmDelete: "Smazat stránku {{title}}?",
      emptyTitle: "Zatím žádná stránka",
      emptyPurpose:
        "Samostatný text, na který odkážete ze zájezdu — třeba o zájezdech na míru do Jižní Koreje.",
      emptyWhere:
        "Objeví se na adrese {{path}} a v detailu zájezdu, když ji vyberete v záložce Obsah.",
      emptyDraft: "Koncept není veřejný nikde — na webu se ukáže až publikovaná stránka.",
      searchEmpty: "Hledání nic nenašlo",
      clearSearch: "Zrušit hledání",
    },
    form: {
      newTitle: "Nová stránka",
      editTitle: "Upravit stránku",
      titlePlaceholder: "např. Zájezdy na míru do Jižní Koreje",
      slugLabel: "Adresní název",
      slugHint: "Stránka bude na adrese {{path}}",
      perexLabel: "Perex",
      perexPlaceholder: "Krátký úvod pod nadpisem a v odkazu ze zájezdu",
      bodyLabel: "Tělo",
      bodyPlaceholder: "Text stránky — členěte nadpisy H2; od tří nadpisů přibude obsah",
      featuredImageLabel: "Hlavní fotka (volitelná)",
      destinationLabel: "Destinace (volitelná)",
      noDestination: "Bez destinace",
      destinationHint: "Nepublikovaná destinace se na webu neodkáže.",
      statusHint: "Koncept vrací na webu 404 a v mapě webu chybí.",
    },
  },
  jobOffers: {
    list: {
      title: "Pracovní nabídky",
      subtitle: "Náborové karty zobrazené v karuselu na úvodní stránce",
      addOffer: "Přidat pracovní nabídku",
      empty:
        "Zatím žádné pracovní nabídky — sekce na úvodní stránce zůstane skrytá, dokud nějakou nepublikujete",
      meta: "{{date}} | Pořadí: {{order}} | Stav: {{status}}",
      confirmDelete: "Smazat tuto pracovní nabídku?",
    },
    form: {
      newTitle: "Nová pracovní nabídka",
      editTitle: "Upravit pracovní nabídku",
      titlePlaceholder: "např. Hledáme průvodce do Vietnamu",
      descriptionRequired: "Popis je povinný",
      descriptionPlaceholder: "Krátký text zobrazený na kartě",
      linkLabel: "Odkaz (cíl CTA)",
      linkPlaceholder: "/kontakt, https://… nebo mailto:info@ckgo2.com",
      linkHint:
        "Kam vede tlačítko „Mám zájem – zjistit více“. Ponechte prázdné pro skrytí tlačítka.",
      cardPhotoLabel: "Fotka na kartě",
      backgroundLabel: "Pozadí sekce (volitelné)",
      backgroundHint: "Když chybí, použije se fotka z karty.",
      publishedDateLabel: "Datum publikace (zobrazeno na kartě)",
    },
  },
  holidays: {
    list: {
      title: "Svátky a prázdniny",
      subtitle:
        "Tlačítka v panelu filtrů na /zajezdy — klik na svátek předvyplní návštěvníkovi termín od–do",
      addHoliday: "Přidat svátek",
      empty:
        "Zatím žádné svátky — sekce v panelu filtrů zůstane skrytá, dokud nějaký nepublikujete",
      meta: "Nejbližší: {{window}} | Oken: {{windows}} | Pořadí: {{order}} | Stav: {{status}}",
      noUpcoming: "žádné budoucí okno",
      confirmDelete: "Smazat tento svátek?",
    },
    form: {
      newTitle: "Nový svátek",
      editTitle: "Upravit svátek",
      namePlaceholder: "např. Velikonoce",
      nameRequired: "Název je povinný",
      slugHint:
        "Stabilní klíč adresy. U svátků převzatých z kódu ho neměňte — drží starší odkazy (easter, christmas, spring-break, may-holidays, autumn-break, summer-break, other-holidays).",
      sortOrderHint: "Pořadí tlačítek v panelu filtrů, od nejmenšího čísla.",
      statusHint: "Rozepsaný svátek nechte jako koncept — na webu se neobjeví.",
    },
    windows: {
      title: "Termínová okna",
      hint: "Dny, které se návštěvníkovi předvyplní do filtru termínu. Klidně je posuňte mimo samotný svátek — když svátek padne na pondělí, lidé odjíždějí už v pátek. Zpravidla jedno okno na školní rok; proběhlá můžete smazat.",
      empty: "Zatím žádné okno — bez něj tlačítko svátku nemá co předvyplnit.",
      from: "Od",
      to: "Do",
      add: "Přidat okno",
      preview: "Na tlačítku se zobrazí: {{label}}",
      incomplete: "Doplňte obě data — okno s jedním datem nejde uložit.",
    },
  },
  podcastEpisodes: {
    list: {
      title: "Podcasty",
      subtitle:
        "Epizody zobrazené na stránce /podcasty — bez publikované epizody se stránka i položka v menu skryjí",
      addEpisode: "Přidat epizodu",
      empty:
        "Zatím žádné epizody — stránka /podcasty i položka v menu zůstanou skryté, dokud nějakou nepublikujete",
      meta: "{{date}} | {{duration}} | Stav: {{status}}",
      confirmDelete: "Smazat tuto epizodu?",
      fromYoutube: "Z playlistu",
      manualBadge: "Ručně upraveno",
    },
    form: {
      newTitle: "Nová epizoda",
      editTitle: "Upravit epizodu",
      titlePlaceholder: "např. Na cestách s Go2: Život na Srí Lance",
      videoUrlLabel: "Odkaz na video (YouTube)",
      videoUrlRequired: "Odkaz na video je povinný",
      videoUrlHint: "Z odkazu se odvodí přehrávač i náhled epizody.",
      thumbnailLabel: "Náhled (volitelné)",
      thumbnailHint: "Prázdné = náhled se vezme přímo z YouTube.",
      publishedAtLabel: "Datum publikace (zobrazeno na kartě)",
      durationLabel: "Délka (minuty)",
      syncNote:
        "Epizoda přišla z YouTube playlistu. Jakmile ručně změníte název, video, datum, délku nebo náhled, sync ji už nikdy nepřepíše. Pouhé přepnutí stavu nebo pořadí ji ze synchronizace nevyjme.",
    },
  },
  wiki: {
    categories: {
      general: "Obecné",
      playbook: "Playbook",
      contacts: "Kontakty",
      sop: "SOP",
    },
    list: {
      title: "Wiki",
      subtitle: "Interní playbook a znalostní báze pro zastupující kolegy.",
      newPage: "Nová stránka",
      thCategory: "Kategorie",
      empty: "Zatím žádné wiki stránky.",
      generalFallback: "Obecné",
    },
    form: {
      newTitle: "Nová wiki stránka",
      editTitle: "Upravit wiki stránku",
      newSubtitle: "Interní playbook / znalostní báze",
      editSubtitle: "Úprava: {{title}}",
      titlePlaceholder: "např. Hanoj — místní kontakty a záludnosti",
      generalOption: "— Obecné (vše) —",
      categoryLabel: "Kategorie",
      contentLabel: "Obsah",
      contentPlaceholder: "Napište playbook…",
    },
  },
  activities: {
    list: {
      title: "Inspirace",
      subtitle: "Správa inspirací",
      newInspiration: "Nová inspirace",
      searchPlaceholder: "Hledat inspirace…",
      allTypes: "Všechny typy",
      allStatuses: "Všechny stavy",
      loadError: "Inspirace se nepodařilo načíst. Zkuste to prosím znovu.",
      empty: "Žádné inspirace",
      thActivity: "Aktivita",
      thDuration: "Délka",
      confirmDelete: "Opravdu chcete smazat „{{title}}“? Tuto akci nelze vrátit zpět.",
    },
    edit: {
      newTitle: "Nová inspirace",
      editTitle: "Upravit inspiraci",
      newSubtitle: "Vytvořte novou inspiraci",
      editSubtitle: "Úprava: {{title}}",
      notFound: "Inspirace nenalezena",
      backToList: "Zpět na inspirace",
    },
    form: {
      activityTypes: "Typy aktivity",
      activityTypesHint:
        "Zaškrtněte všechny typy, které inspirace nabízí. Na webu se ukáže pod chipem každého zaškrtnutého typu.",
    },
    tabs: {
      basic: "Základní info",
      description: "Popis",
      gallery: "Galerie",
      included: "V ceně a štítky",
      videos: "Videa a reels",
      tips: "Tipy",
      related: "Související",
    },
    basic: {
      basicInfoTitle: "Základní informace",
      titlePlaceholder: "např. Plavba zátokou Ha Long",
      slugLabel: "URL slug",
      slugPlaceholder: "např. plavba-zatokou-ha-long",
      difficultyLabel: "Náročnost",
      selectDifficulty: "Vyberte náročnost",
      durationLabel: "Délka",
      durationPlaceholder: "např. půl dne, 3 hodiny, celý den",
      locationLabel: "Lokalita",
      locationPlaceholder: "např. zátoka Ha Long, Quang Ninh",
      heroPlaceholder: "např. Zátoka Ha Long",
      headingPlaceholder: "např. Plavba zátokou Ha Long – cesta smaragdovými vodami",
      shortDescriptionTitle: "Krátký popis",
      shortDescriptionPlaceholder: "Krátké shrnutí pod nadpisem stránky a na kartách…",
      featuredActivity: "Upřednostnit v Oblíbených inspiracích",
    },
    description: {
      title: "Podrobný popis",
      placeholder: "Podrobný popis aktivity…",
    },
    gallery: {
      title: "Obrázky galerie",
    },
    included: {
      includedTitle: "Co je v ceně",
      includedPlaceholder: "např. Oběd, Průvodce, Vybavení",
      includedEmpty: "Zatím žádné položky",
      addItem: "Přidat položku",
      tagsTitle: "Štítky",
      tagsPlaceholder: "např. loď, plavba, výhledy",
      tagsEmpty: "Zatím žádné štítky",
      addTag: "Přidat štítek",
    },
    videos: {
      reelsTitle: "Social reels (Nechte se inspirovat)",
      reelsDescription: "Přidejte instagramové reels nebo odkazy na krátká videa s náhledy.",
      videosTitle: "Videa",
      videosDescription: "Přidejte YouTube nebo jiné video odkazy k této aktivitě.",
      empty: "Zatím žádná videa",
      videoTitlePlaceholder: "Titulek videa",
      addVideo: "Přidat video",
    },
    tips: {
      tipsTitle: "Užitečné tipy",
      prefill: {
        beforeTrip: "Před cestou",
        onSite: "Na místě",
        practical: "Praktické informace",
      },
      testimonialTitle: "Reference",
      quoteLabel: "Citát",
      quotePlaceholder: "Citát z reference zákazníka…",
      authorNameLabel: "Jméno autora",
      authorNamePlaceholder: "např. Jan Novák",
      authorPhotoLabel: "Fotka autora",
    },
    related: {
      title: "Související inspirace",
      description:
        "Vyberte, které inspirace se mají na webu zobrazit v sekci „Oblíbené inspirace“. Pokud žádné nevyberete, web je vybere sám — z destinace této inspirace a jejích lokalit.",
      pickerLabel: "Oblíbené inspirace",
      pickerPlaceholder: "Hledat inspirace…",
      autoTitle: "Co web zobrazí bez ručního výběru",
      autoScope: "Vybírá se z destinace {{destination}} a jejích lokalit.",
      autoLoading: "Načítám náhled…",
      autoUnsaved: "Náhled automatického výběru se zobrazí po prvním uložení inspirace.",
      autoNoDestination:
        "Inspirace nemá publikovanou destinaci, takže se sekce „Oblíbené inspirace“ na webu vůbec nezobrazí. Přiřaďte destinaci v Základních informacích, nebo vyberte inspirace ručně.",
      autoEmpty:
        "V destinaci {{destination}} není žádná další publikovaná inspirace, takže se sekce na webu nezobrazí.",
      autoOverridden: "Váš ruční výběr má přednost. Bez něj by web zobrazil:",
      outsideScopeTitle: "Vybrané inspirace mimo destinaci {{destination}}",
      outsideScopeText:
        "Nadpis sekce na webu jmenuje destinaci, takže inspirace z jiné země pod ním čtou jako chyba. Zvažte jejich odebrání.",
    },
    linkedTrips: {
      title: "Zájezdy, které ji obsahují",
      hint: "Na webu: vybrané zájezdy se ukážou na stránce inspirace v sekci ‚Zájezdy, na kterých to zažijete‘ před ostatními zájezdy destinace.",
      pickerLabel: "Vybrané zájezdy",
      searchPlaceholder: "Hledat publikované zájezdy…",
      unpublishedSuffix: "(nepublikováno)",
      blockedNew: "Vazby půjde přidat po prvním uložení.",
      loading: "Načítám vazby…",
    },
  },
  homepage: {
    title: "Úvodní stránka",
    subtitle: "Upravte hero sekci, hity měsíce a nejoblíbenější destinace",
    heroTitle: "Hero",
    subtitleLabel: "Podtitulek",
    backgroundImageLabel: "Obrázek na pozadí",
    monthlyHitsTitle: "Cestovatelské hity měsíce",
    monthlyHitsHint:
      "Na pořadí záleží — první položka se zobrazí jako první. Ponechte prázdné pro výchozí obsah.",
    tripOption: "Zájezd: {{label}}",
    inspirationOption: "Inspirace: {{label}}",
    monthlyHitsLimitReached:
      "Dosažena mez {{max}} hitů měsíce. Další přidáte, až některý odeberete.",
    typeTrip: "zájezd",
    typeActivity: "aktivita",
    popularDestinationsTitle: "Nejoblíbenější destinace",
    popularDestinationsHint: "Na pořadí záleží. Ponechte prázdné pro výchozí obsah.",
    popularDestinationsLimitReached:
      "Dosažena mez {{max}} destinací. Další přidáte, až některou odeberete.",
    sizeLarge: "velká",
    sizeSmall: "malá",
    addPlaceholder: "Přidat…",
    groupCountries: "Země",
    groupPlaces: "Lokality",
    draftSuffix: "koncept",
    draftWarning: "Koncept — na webu se karta nezobrazí, dokud destinaci nepublikujete.",
    aboutHeroTitle: "Stránka O nás",
    aboutHeroHint:
      "Úvodní fotka a citát na stránce /o-nas. Bez vybrané fotky se úvodní blok vůbec nezobrazí.",
    aboutHeroImageLabel: "Úvodní fotka",
    aboutHeroQuoteLabel: "Citát",
    aboutHeroQuoteHint: "Zobrazí se v uvozovkách přes fotku. Prázdný citát nahradí nadpis „O nás“.",
    tripTypeImagesTitle: "Fotky karet typů zájezdů",
    tripTypeImagesHint:
      "Tři karty v sekci „Zážitky podle vašich představ“ na úvodní stránce. Prázdný výběr znamená kartu bez fotky.",
  },
  promoBar: {
    title: "Horní lišta",
    subtitle: "Tenký pruh nad hlavičkou webu — vidí ho návštěvník na každé stránce.",
    sectionTitle: "Obsah lišty",
    hint: "Ve výchozím stavu je lišta vypnutá — zobrazí se jen se zapnutím a vyplněným textem.",
    cacheHint: "Změna se na webu projeví do ~3 minut (stránky si nastavení chvíli drží v cache).",
    enabled: "Zobrazit horní lištu",
    textLabel: "Text",
    hrefLabel: "Odkaz (volitelný)",
    hrefHint:
      "Interní cesta (např. /zajezdy) nebo celá https:// URL. Interní cesty se validují proti route mapě.",
    saveFailed: "Lištu se nepodařilo uložit.",
    storedInvalid: "Pozor:",
  },
  googleReviews: {
    origin: {
      export: "Export",
      manual: "Ruční",
    },
    list: {
      title: "Google recenze",
      count_one: "{{count}} recenze",
      count_few: "{{count}} recenze",
      count_other: "{{count}} recenzí",
      uploadExport: "Nahrát export",
      addManual: "Přidat ručně",
      filterOrigin: "Původ",
      filterOriginAll: "Všechny původy",
      filterDestination: "Destinace",
      filterDestinationAll: "Všechny destinace",
      filterDestinationNone: "Bez destinace",
      colAuthor: "Autor",
      colDate: "Datum",
      colExcerpt: "Text",
      colDestination: "Destinace",
      colOrigin: "Původ",
      colActions: "Akce",
      noDestination: "Bez destinace",
      lockedTitle: "Destinaci vybrala redakce, import ji nezmění",
      emptyAll: "Zatím žádné Google recenze, nahrajte export nebo přidejte ručně",
      emptyFiltered: "Filtru neodpovídá žádná Google recenze.",
      loadError: "Google recenze se nepodařilo načíst.",
      pagePrev: "Předchozí",
      pageNext: "Další",
      pageOf: "Stránka {{page}} z {{total}}",
      actionFixDestination: "Opravit destinaci",
      actionEdit: "Upravit",
      actionDelete: "Smazat",
      actionRemovePermanently: "Odstranit natrvalo",
      deleteTitle: "Smazat ruční recenzi?",
      deleteMessage:
        "Ručně zadaná recenze se smaže. Pokud je i v některém dalším exportu, import ji znovu přidá.",
      deleteConfirm: "Smazat",
      removeTitle: "Odstranit natrvalo?",
      removeMessage:
        "Jméno autora a text recenze zmizí. Zůstane jen identifikátor, aby ji další nahrání exportu nevrátilo. Akci nejde vrátit.",
      removeConfirm: "Odstranit natrvalo",
      cancel: "Zrušit",
    },
    upload: {
      title: "Nahrát export Google Takeout",
      intro:
        "Vyberte ZIP stažený ze služby Google Takeout (data Firemního profilu na Googlu). Když Takeout export rozdělil na víc dílů, vyberte všechny najednou. Soubor se čte v prohlížeči, na server jdou jen recenze vybrané lokace a nic se neuloží, dokud nepotvrdíte souhrn.",
      fileLabel: "Soubory exportu (ZIP)",
      reading: "Čtu export…",
      errorNotZip: "Vybraný soubor není archiv ZIP.",
      errorNotTakeout: "ZIP neobsahuje recenze žádné lokace.",
      errorUnsupportedZip: "ZIP je šifrovaný nebo používá nepodporovanou kompresi.",
      errorNoReviews: "Lokace v exportu nemají žádné recenze.",
      errorUnexpected: "Export se nepodařilo přečíst.",
      expected:
        "Očekávám ZIP ze služby Google Takeout s daty Firemního profilu na Googlu, ve kterém je složka lokace se soubory reviews.json.",
      fileName: "Soubor: {{name}}",
      pickAnother: "Vybrat jiný soubor",
      chooseLocationTitle: "Vyberte lokaci",
      chooseLocationHint:
        "Export obsahuje víc lokací. Vyberte tu, jejíž recenze patří k tomuto webu.",
      locationReviews_one: "{{count}} recenze v exportu",
      locationReviews_few: "{{count}} recenze v exportu",
      locationReviews_other: "{{count}} recenzí v exportu",
      continue: "Pokračovat",
      previewing: "Počítám souhrn…",
      summaryTitle: "Souhrn před uložením",
      confirm: "Potvrdit a uložit",
      cancel: "Zrušit",
      doneTitle: "Uloženo",
      close: "Zavřít",
    },
    summary: {
      location: "Lokace",
      placeId: "Identifikátor místa",
      placeIdMissing: "bez identifikátoru místa",
      exportDate: "Datum exportu",
      exportDateFromFilename: "z názvu souboru",
      exportDateFromUpload: "den nahrání",
      total: "Recenzí v exportu",
      score: "Známka",
      distribution: "Rozložení",
      starsRow: "{{stars}} ★",
      added: "Přibude",
      changed: "Změní se",
      deleted: "Smaže se",
      manualPaired: "Spárované ruční",
      manualAmbiguous: "Nejednoznačné ruční (nespárováno)",
      skippedRemoved: "Přeskočené odstraněné natrvalo",
      deletedWarning: "Recenze, které v exportu chybějí, se smažou.",
      resultAdded: "Přibylo",
      resultChanged: "Změnilo se",
      resultDeleted: "Smazalo se",
      noValue: "—",
    },
    form: {
      newTitle: "Nová Google recenze",
      editTitle: "Upravit Google recenzi",
      author: "Autor",
      date: "Datum recenze",
      text: "Text recenze",
      textHint: "Původní text autora, bez překladu, který přidává Google.",
      destination: "Destinace",
      destinationNone: "Bez destinace",
      destinationHint:
        "Předvyplní se podle textu. Když destinaci vyberete sami, zamkne se a nahrání exportu ji nezmění.",
      starsHint: "Ruční Google recenze má vždy pět hvězd.",
      exportNotEditable: "Exportovanou recenzi nejde upravit, jen opravit destinaci v seznamu.",
      backToList: "Zpět na Google recenze",
      loadError: "Google recenzi se nepodařilo načíst.",
    },
    destinationDialog: {
      title: "Opravit destinaci: {{author}}",
      label: "Destinace",
      none: "Bez destinace",
      hint: "Opravená destinace zůstane i po dalším nahrání exportu.",
      save: "Uložit",
      cancel: "Zrušit",
    },
  },
};
